import type { MaybeRefOrGetter, Ref } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { computed, toValue, unref } from 'vue';
import { getApi } from './api';

export type ShipmentsTrackBatchRow = {
  shipment_id: number;
  device_id: number;
  data: {
    encoded_polyline: string;
    timestamp: string;
    battery: string;
    fix_type?: string;
    accuracy?: string;
    count?: number;
  };
};

export default function getAccountShipmentsTracksBatch(
  accountId: Ref<number | null | undefined> | number,
  shipmentIds: Ref<number[]> | number[],
  options: { enabled: MaybeRefOrGetter<boolean> },
) {
  return useQuery({
    queryKey: [
      'v2',
      'account-shipments-tracks',
      () => unref(accountId),
      () => unref(shipmentIds),
    ],
    queryFn: async (): Promise<ShipmentsTrackBatchRow[]> => {
      const { api, baseURL } = getApi();
      const aid = unref(accountId);
      const ids = unref(shipmentIds);
      const res = await api.get(`/api/v2/accounts/${aid}/shipments-tracks`, {
        baseURL,
        params: { shipment_ids: (ids ?? []).join(',') },
      });
      return (res.data?.data ?? []) as ShipmentsTrackBatchRow[];
    },
    enabled: computed(() => {
      const aid = unref(accountId);
      const ids = unref(shipmentIds);
      const paramsOk =
        aid != null && aid !== 0 && Array.isArray(ids) && ids.length > 0;
      return paramsOk && toValue(options.enabled);
    }),
  });
}
